import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { fleetMessageSchema } from '../schemas/fleet-message.schema';

/**
 * Gets Routing Profiles assigned to a specific Vehicle Group
 * @param vehicleGroupId Vehicle Group ID of group whose Routing Profiles are being requested
 * @returns Array of IDs
 */
export function getVehicleGroupsIdRoutingProfiles(
  this: unknown,
  vehicleGroupId: number
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment
          .resolve(this)
          .vehicleGroupsIdRoutingProfilesUrl(String(vehicleGroupId)),
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      fleetMessageSchema.extend({
        data: z.array(z.number()),
      })
    )
  );
}
